import { render, staticRenderFns } from "./FacetValuesSelection.vue?vue&type=template&id=c8f8873e"
import script from "./FacetValuesSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./FacetValuesSelection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports